import './style.css'

const choices = []
let currentPage = 'home'
let deferredPrompt = null

// Array of light pastel colors for result page
const pastelColors = [
  '#CBF3F0', '#B6F9C9', '#FFE5E5', '#E0F4FF', '#F9F3CC',
  '#D4E2D4', '#FFCEFE', '#DDF7E3', '#FFF6DC', '#DFCCFB',
  '#FFE5CA', '#C4DFDF', '#E5D1FA', '#FFF4D2', '#D4E7C5',
  '#F8E8EE', '#E3F4F4', '#F5EFE7', '#DDFFBB', '#F6FDC3'
]

// DOM Elements
const homePage = document.getElementById('home-page')
const countdownPage = document.getElementById('countdown-page')
const resultPage = document.getElementById('result-page')
const choicesContainer = document.querySelector('.choices-container')
const letsGoButton = document.getElementById('lets-go')
const retryButton = document.getElementById('retry')
const startAgainButton = document.getElementById('start-again')
const countdownElement = document.querySelector('.countdown')
const resultElement = document.querySelector('#result-page h2')

// Register Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => console.log('Service Worker registered'))
      .catch(error => console.error('Service Worker registration failed:', error))
  })
}

// Handle PWA installation
window.addEventListener('beforeinstallprompt', (e) => {
  deferredPrompt = e;
  const installPrompt = document.getElementById('pwa-install-prompt');
  if (installPrompt) installPrompt.classList.remove('hidden');
});

document.getElementById('install-button')?.addEventListener('click', async () => {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  if (outcome === 'accepted') {
    const installPrompt = document.getElementById('pwa-install-prompt');
    if (installPrompt) installPrompt.classList.add('hidden');
  }
  deferredPrompt = null;
});

// Add new choice input when the last input is filled
function handleChoiceInput(event) {
  const inputs = document.querySelectorAll('.choice-input')
  const lastInput = inputs[inputs.length - 1]
  
  if (event.target === lastInput && event.target.value.trim() !== '') {
    const newInput = document.createElement('input')
    newInput.type = 'text'
    newInput.className = 'choice-input'
    newInput.placeholder = `Choice ${inputs.length + 1} here`
    newInput.addEventListener('input', handleChoiceInput)
    choicesContainer.appendChild(newInput)
  }
}

// Show specified page and hide others
function showPage(pageId) {
  currentPage = pageId
  homePage.classList.toggle('hidden', pageId !== 'home')
  countdownPage.classList.toggle('hidden', pageId !== 'countdown')
  resultPage.classList.toggle('hidden', pageId !== 'result')

  // Update background color based on current page
  if (pageId === 'home') {
    document.body.style.backgroundColor = 'rgb(182, 249, 201)'
  } else if (pageId === 'countdown') {
    document.body.style.backgroundColor = 'rgb(163, 217, 255)'
  } else if (pageId === 'result') {
    const randomColor = pastelColors[Math.floor(Math.random() * pastelColors.length)]
    document.body.style.backgroundColor = randomColor
  }
}

// Start countdown animation
async function startCountdown() {
  showPage('countdown')
  
  for (let i = 3; i >= 1; i--) {
    countdownElement.textContent = i
    await new Promise(resolve => setTimeout(resolve, 1000))
  }
  
  showResult()
}

// Show random result
function showResult() {
  const inputs = document.querySelectorAll('.choice-input')
  const validChoices = Array.from(inputs)
    .map(input => input.value.trim())
    .filter(value => value !== '')
  
  if (validChoices.length < 2) {
    showPage('home')
    return
  }
  
  const randomChoice = validChoices[Math.floor(Math.random() * validChoices.length)]
  resultElement.textContent = randomChoice
  showPage('result')
}

// Event Listeners
document.querySelectorAll('.choice-input').forEach(input => {
  input.addEventListener('input', handleChoiceInput)
})

// Create alert overlay element
const alertOverlay = document.createElement('div')
alertOverlay.className = 'alert-overlay'
alertOverlay.innerHTML = `
  <div class="alert-dialog">
    <div class="alert-message">Please enter at least 2 choices</div>
    <button class="action-button">OK</button>
  </div>
`
document.body.appendChild(alertOverlay)

// Show alert function
function showAlert() {
  alertOverlay.classList.add('show')
  const okButton = alertOverlay.querySelector('.action-button')
  okButton.focus()
  
  const hideAlert = () => {
    alertOverlay.classList.remove('show')
    okButton.removeEventListener('click', hideAlert)
    document.removeEventListener('keydown', handleKeyDown)
  }
  
  const handleKeyDown = (e) => {
    if (e.key === 'Escape' || e.key === 'Enter') {
      hideAlert()
    }
  }
  
  okButton.addEventListener('click', hideAlert)
  document.addEventListener('keydown', handleKeyDown)
}

// Modify letsGoButton click handler
letsGoButton.addEventListener('click', () => {
  const inputs = document.querySelectorAll('.choice-input')
  const validChoices = Array.from(inputs)
    .map(input => input.value.trim())
    .filter(value => value !== '')

  if (validChoices.length < 2) {
    showAlert()
    return
  }
  startCountdown()
})

retryButton.addEventListener('click', () => {
  if (currentPage === 'result') startCountdown()
})

startAgainButton.addEventListener('click', () => {
  document.querySelectorAll('.choice-input').forEach((input, index) => {
    if (index > 1) input.remove()
    else input.value = ''
  })
  showPage('home')
})
